
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M29.3783 0.199219C31.8545 0.199219 33.8 2.19706 33.8 4.73976C33.8 4.9012 33.7922 5.05861 33.7767 5.21467C33.7922 5.38687 33.8 5.56177 33.8 5.73935V28.2604C33.8 31.348 31.4118 33.7992 28.4063 33.7992H5.59377C2.58818 33.7992 0.200012 31.348 0.200012 28.2604V5.73935C0.200012 5.56446 0.207779 5.3936 0.223311 5.22408C0.208255 5.06311 0.20048 4.90149 0.200012 4.73976C0.200012 2.19706 2.14549 0.199219 4.62168 0.199219H29.3783ZM23.8386 12.6915C23.2892 12.6915 22.9234 13.0566 22.9234 13.6042V15.7945C22.9234 19.0801 20.7258 21.5449 17.7055 21.6355C16.2409 21.7274 14.8674 21.1798 13.7699 20.1752C12.58 19.0801 11.9381 17.5292 11.9381 15.8865V13.6042C11.9381 13.0566 11.5723 12.6915 11.0229 12.6915C10.4735 12.6915 10.1077 13.0566 10.1077 13.6042V15.8865C10.1077 17.9849 11.0229 19.9927 12.4875 21.4529C13.861 22.7306 15.6003 23.4608 17.4308 23.4608H17.7966C21.7335 23.2782 24.7539 19.9927 24.7539 15.7945V13.6042C24.7539 13.0566 24.3867 12.6915 23.8386 12.6915ZM29.8266 1.06076H5.03492C3.08668 1.06076 1.49232 2.70845 1.49232 4.7223C1.49232 6.73614 3.08668 8.38383 5.03492 8.38383H29.8266C31.7749 8.38383 33.3692 6.73614 33.3692 4.7223C33.3692 2.70845 31.7749 1.06076 29.8266 1.06076Z"
    fill="currentColor"
  />
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'ShoppingBag',
    }) as DefineComponent
    </script>
    